/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ShapesFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="shapes-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M9.595 2.706L10.974 9.495L4.405 7.294L9.595 2.706Z" data-tinysvg-shape="polygon" data-tinysvg-polygon="8.325 6.498 4 3 18.52 0" stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
          <circle cx={6.916} cy={15.2} r={3.896} stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
          <rect x={13.85} y={9} width={7.85} height={7.85} stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
    </svg>
  )
}
